import PropTypes from "prop-types"

import Navbar from "../../ui/Navbar/Navbar"

import "./SettingsLayout.css"
import { UserProfile } from "../../components"
import SettingsTopbar from "../../ui/Navbar/SettingsTopbar"

function SettingsLayout(props) {
    const { children, name } = props

    return (
        <>
        <div className="main">
            <div className="main__header__navbar">
                <Navbar view={name} settings />
            </div>
            <div className="main__content">
                <div className="settings__container">
                    <div className="main__header">
                        <SettingsTopbar settingsName={name} />
                    </div>
                    <div className="main__content__user">
                        <UserProfile />
                    </div>
                    {children}
                    <div className="settings-layout__powered-by powered-by">
                        <a className="powered-by__tag" href="https://www.climate.ai" target="_blank">
                            <div>Powered by</div>
                            <img alt="ClimateAI logo" src="/Climate-AI-Color-Logo.png" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

SettingsLayout.propTypes = {
    children: PropTypes.node,
}

export default SettingsLayout
